module.exports = __webpack_public_path__ + "5c189774ed9d1d7453944590be6880d6.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/broschuere20_image.jpg
// module id = 748
// module chunks = 0